import { Link } from "react-router-dom";
import { GoArrowRight } from "react-icons/go";
import React, { useEffect, useState } from "react";
import { FaShoppingCart } from "react-icons/fa";
import { FaGreaterThan } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { GoLocation } from "react-icons/go";
import "./ImagingDetail.css";
import { getDepartmentWiseCenter, getTestList } from "../../api/api";
import { getDepartmentInfo } from "../../utils/helper";
import CustomLoader from "../../common/loader/CustomLoader";
import CustomPagination from "../../common/CustomPagination";
import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import PackageDetailsModal from "../OurPackagesPageElements/PackageDetailsModel";
import { useCart } from "../../Contexts/Cart.contexts";
import { TruncateText } from "../../common/TruncateText";
import CenterCard from "../../common/CenterCard";
import ServiceDetails from "../../ServiceComponents/ServiceDetails";
import ServiceList from "./../../DB/AllServicesList";
import rbdLogo from "../../Assets/rbdLogo.png";
import cornerIcon from "../../Assets/cornerIcon.png";

// import ServiceData from "../DB/ServiceData";
//import './ServiceComponentsCSS/ServiceDetails.css';

// =============================
// Imaging Detail Section
// =============================

const TestSkeletonCard = () => {
  return (
    <div className="packageCard mainPackageCard wide-card test-packageCard test-skeleton">
      <div className="skeleton skeleton-image"></div>
      <div className="skeleton skeleton-line"></div>
      <div className="skeleton skeleton-line short"></div>
      <div className="skeleton skeleton-button"></div>
    </div>
  );
};
export default function ImagingDetailSection() {
  const { addToCart, cartItems, setCartItems } = useCart();
  const { dept } = useParams();
  const [copiedId, setCopiedId] = useState(null);
  const [search, setSearch] = useState("");
  const [testData, setTestData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const serviceInfo = getDepartmentInfo(dept);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [testCenters, setTestCenters] = useState([]);

  // Fetch data on mount
  useEffect(() => {
    fetchTestListData();
    fetchTestCenters();
  }, []);

  // Fetch test list
  const fetchTestListData = async () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      Center_ID: "",
      search_key: "",
    };
    try {
      setLoading(true);
      const res = await getTestList(payload);
      const filterTests =
        res?.data?.data?.filter((item) => item.Package === "N") || [];
      setTestData(filterTests);
    } catch (error) {
      console.error("Error fetching test list:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch centers
  const fetchTestCenters = async () => {
    try {
      const payload = { deptName: dept };
      const res = await getDepartmentWiseCenter(payload);
      setTestCenters(res?.data?.data || []);
    } catch (error) {
      console.error("Error fetching test centers:", error);
    }
  };

  // Filtering
  const filteredTests = testData
    ?.filter(
      (t) => t?.Department?.toLowerCase().trim() === dept?.toLowerCase().trim()
    )
    ?.filter((t) =>
      t?.service_name?.toLowerCase().includes(search.toLowerCase())
    );

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginatedTests = filteredTests.slice(indexOfFirstItem, indexOfLastItem);

  // Handlers
  const handleView = (item) => {
    setSelectedPackage(item);
    setIsModalOpen(true);
  };

  const handleAddToCart = (packageData) => {
    if (packageData?.service_id === cartItems?.service_id) {
      toast.error("Item already in cart", {
        duration: 3000,
        id: "already-in-cart",
      });
    }
    addToCart({
      id: packageData.service_id,
      product: packageData?.service_name,
      price: packageData.price,
      quantity: 1,
    });
  };

  const handleToggleCart = (card) => {
    const isAdded =
      cartItems && cartItems.some((item) => item.id === card.service_id);
    if (isAdded) {
      setCartItems((prev) =>
        prev.filter((item) => item.id !== card.service_id)
      );
      toast.success("Item removed from cart", {
        duration: 3000,
        id: "item-removed",
      });
    } else {
      handleAddToCart(card);
      toast.success("Item added to cart", {
        duration: 3000,
        id: "item-added",
      });
    }
  };
  const handleViewDetails = (card) => {
    setSelectedPackage(card);
    setIsModalOpen(true);
  };
  const renderCard = (card, index) => {
    const isAdded =
      cartItems && cartItems.some((item) => item.id === card.service_id);
    const handleToggleCart = () => {
      if (isAdded) {
        // remove from cart
        setCartItems((prev) =>
          prev.filter((item) => item.id !== card.service_id)
        );
      } else {
        // add to cart
        // setCartItems((prev) => [...prev, { id: card.service_id, ...card }]);
        handleAddToCart(card);
      }
    };
    return (
      <div key={index} className="carouselCardWrapper">
        <div className="packageCard mainPackageCard wide-card test-packageCard">
          <div className="cornerImage">
            <div className="upperCardText">
              <img className="logoimg" src={rbdLogo} alt="RBD logo" />
            </div>
            <img
              src={cornerIcon}
              alt="corner icon"
              style={{ width: "3.5rem" }}
            />
          </div>

          <div className="cardTitlePack mainpackageTitlePack">
            <h2 style={{ color: "gray", fontSize: "16px" }}>
              <TruncateText text={card?.service_name} maxLength={25} />
            </h2>
            <span
              style={{ color: "#555", fontSize: "0.8rem", marginBottom: "4px" }}
            >
              Test Key: <TruncateText text={card?.service_key} maxLength={20} />
            </span>
          </div>

          <div className="testPackageMidSection">
            <div className="priceSection">
              <h3 style={{ margin: "0", color: "gray", fontSize: "1rem" }}>
                &#8377; {Number(card.price)}/-
              </h3>
            </div>

            <div className="copiLinkSection">
              <p
                onClick={() => handleCopyLink(card)}
                style={{
                  color: "#007bff",
                  // textDecoration: "underline",
                  cursor: "pointer",
                  marginTop: "6px",
                  fontSize: "13px",
                }}
              >
                🔗 {copiedId === card.service_id ? "Link Copied!" : "Copy Link"}
              </p>
            </div>
          </div>

          <div className="cardLowerSec">
            <button
              className="rbdButton"
              title="Click to View Details"
              onClick={() => handleViewDetails(card)}
            >
              <span className="btn-text">View Details</span>
            </button>

            <button
              className={`rbdButton addCartBtn ${isAdded ? "added" : ""}`}
              title={isAdded ? "Added" : "Item Added"}
              onClick={handleToggleCart}
            >
              <span className="btn-text">
                {isAdded ? "Added Item" : "Add to Cart"}
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  //changes

  const handleCopyLink = async (card) => {
    // const link = ${window.location.origin}/RBD/test-packages/${card.service_id};

    // const link = `${window.location.origin}/rbweb-react/test-packages/${card.service_id}`;

    
    const link = `${window.location.origin}/test-packages/${card.service_id}`;

    try {
      await navigator.clipboard.writeText(link);
      setCopiedId(card.service_id);

      setTimeout(() => {
        setCopiedId(null);
      }, 3000);
    } catch (err) {
      console.error("Failed to copy link", err);
    }
  };

  return (
    <div className="test-container">
      {/* Header */}
      <ServiceHeader
        childClass={serviceInfo?.className}
        breadcrumb={
          <>
            Services <FaGreaterThan size={15} /> {serviceInfo?.title}
          </>
        }
        title={serviceInfo?.title}
      />

      {/*<ServiceDetails serviceName={dept}/>*/}
      <>
        <div className="serviceBody-wrapper">
          <ServiceDetails serviceName={dept} />

          <div className="left-sidebar">
            <div className="services-box">
              <h4 className="centers-heading">Centres Available</h4>
              {/* <h4>Other Services</h4> */}
              {testCenters.map((svs, index) => {
                const url = svs.center_URL.startsWith("http")
                  ? svs.center_URL
                  : `https://${svs.center_URL}`;

                // CHANGES
                return (
                  <li key={index}>
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {svs.center_name}
                      <span className="arrow">
                        <GoLocation size={18} />
                      </span>
                    </a>
                  </li>
                );
              })}
            </div>
          </div>
        </div>
      </>

      {/* <ServiceDetails serviceName={dept?.toUpperCase().replace(/-/g, "")} />*/}

      {/* {loading && <CustomLoader />} */}

      {/* CHANGES DONE */}
      <div className="radiology-card">
        <div className="mainPackageCardSection">
          {/* {loading ? (
            <div style={{ textAlign: "" }}></div>
          ) : (
            paginatedTests.map((card, index) => renderCard(card, index))
          )} */}

          {loading
            ? Array.from({ length: 6 }).map((_, index) => (
                <TestSkeletonCard key={index} />
              ))
            : paginatedTests.map((card, index) => renderCard(card, index))}

          <PackageDetailsModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            packageData={selectedPackage}
          />
        </div>

        {/* Pagination */}
        {/*{filteredTests.length > itemsPerPage && (
        <div style={{ marginTop: "1rem" }}>
          <CustomPagination
            totalPages={filteredTests.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}*/}

        {/* Pagination */}
        {filteredTests.length > itemsPerPage && (
          <div style={{ marginTop: "1rem" }}>
            <CustomPagination
              totalPages={Math.ceil(filteredTests.length / itemsPerPage)}
              currentPage={currentPage}
              onChange={(page) => setCurrentPage(page)}
            />
          </div>
        )}
      </div>
      {/* Pagination */}
      {/*{filteredTests.length > itemsPerPage && (
        <div style={{ marginTop: "1rem" }}>
          <CustomPagination
            totalPages={filteredTests.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}*/}

      {/* Modal */}
      <PackageDetailsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        packageData={selectedPackage}
      />
    </div>
  );
}
